import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

const Logout = () => {
    useEffect(()=>{
        localStorage.clear();
    },[]);
  return (
    <div id='logout'>
      <div className="main-container">
        <div className="top-container">
          <i className="fa-solid fa-check-circle bigger-size" aria-hidden="true"></i>
        </div>

        <div className="bottom-container">
          <p>You've logged out successfully!</p>
          <Link to={'/login'} className='button'>Back to Login</Link>
        </div>
      </div>




      
    </div>
  )
}

export default Logout;
